import { BaseLayer } from '@fareye/ui'
import { TEnvironment } from './utility/types'
const MAP_API_KEY = ''

const production = {
  production: true,
  baseURL: 'https://transportation.fareye.co',
  mapKey: MAP_API_KEY,
  defaultBaseLayer: BaseLayer.GMROADS
}

// TODO : TO BE CHANGED BEFORE MERGING INTO TRN-91
const staging = {
  production: false,
  baseURL: 'https://tpt-preprod.fareye.co',
  settings: 'https://tpt-preprod.fareye.co',
  alertSettings: 'https://tpt-preprod.fareye.co',
  poi: 'https://tpt-preprod.fareye.co',
  postUrl: 'tpt-preprod.fareye.co',
  addPoi: 'https://tpt-preprod.fareye.co',
  addPois: 'https://tpt-preprod.fareye.co',
  mapKey: MAP_API_KEY,
  defaultBaseLayer: BaseLayer.OSMMAPNIK
}

let { API_URL, MAP_KEY, NODE_ENV, PRODUCTION } = window.__RUNTIME_CONFIG__
let processEnv = process.env.REACT_APP_ENV as TEnvironment
let localEnv = {}
switch (processEnv) {
  case 'staging':
    localEnv = staging
    break
  case 'production':
    localEnv = production
    break
}
let environment = {
  baseURL: API_URL,
  defaultBaseLayer: BaseLayer.GMROADS,
  mapKey: MAP_KEY,
  production: PRODUCTION,
  processEnv: NODE_ENV,
  aerisLayer: {},
  postUrl: '',
  ...localEnv
}
export default { ...environment }
